import { ArticleCardData } from '@/globalTypes';
import { formatMyStringAsSlug } from '@/lib/globalHooks';
import Link from 'next/link';


const ArticleCard = ({ baseClass, article, baseURL }: { baseClass: string, article: ArticleCardData, baseURL: string }) => {
    const pathname = location.pathname;
    const { id, attributes } = article;
    const { title, content, updatedAt, publishedAt } = attributes;
    return (
        <div key={publishedAt} className={`${baseClass}__article grid gap-6  rounded-2xl bg-white text-[#1D4749] font-bold p-6 w-[100%] md:w-[70%]  xl:w-[50%]   mx-auto shadow-articleCard`}>
            <div className={`${baseClass}__article__heading w-full h-max capitalize text-base`}>
                {title}
            </div>
            <div key={updatedAt} className={`${baseClass}__article__sub-headings  w-full inline-grid gap-5 grid-cols-2 shadow-inset-dark-green `} >
                {content.filter((contentBlock: any) => (contentBlock.type === 'heading' && contentBlock.level == '2')).map(({ children }) => {
                    return (
                        children.map(({ type, text }: any) => {
                            // eslint-disable-next-line react/jsx-key
                            return <Link href={`${baseURL}${pathname === "/learn-more-web"?formatMyStringAsSlug(title):id}#${formatMyStringAsSlug(text)}`}><div
                                key={text}
                                className={`${baseClass}__article_sub-heading p-3 min-h-20 flex flex-col justify-center bg-[#1D4749] rounded-2xl text-white bg-shine bg-no-repeat bg-cover hover:cursor-pointer`}
                            >
                                <div className={`${baseClass}__articleCard_blog__sub-heading text-center capitalize text-xs`}>
                                    {text}
                                </div>
                            </div>
                            </Link>

                        })
                    )
                })}
            </div>
        </div>
    )
}

export default ArticleCard